// JsFromRoutes CacheKey 820fc3de061861299552b1b0095101f5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/add-back/:token'),
  create: /* #__PURE__ */ definePathHelper('post', '/add-back/:token'),
  update: /* #__PURE__ */ definePathHelper('patch', '/add-back/:token'),
}
